/**
 * Created by razial on 21.09.2026.
 */

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    LANTERN_WINDOW_TIMER_TEXT: {
        name: "nostroke",
        size: 40,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    }
});

cleverapps.overrideStyles(cleverapps.styles.LanternWindow, {
    text: {
        height: 110,
        width: 690
    },
    timer: {
        x: { align: "center" },
        y: { align: "top", dy: -30 },
        font: cleverapps.styles.FONTS.LANTERN_WINDOW_TIMER_TEXT
    },
    bonuses: {
        x: { align: "center" },
        y: { align: "bottom", dy: 25 },

        amount: {
            x: { align: "right", dx: -15 },
            y: { align: "bottom", dy: 20 },

            bg: {
                x: { align: "center" },
                y: { align: "center", dy: -5 },
                width: 86,
                height: 86
            }
        },

        bonusBg: {
            width: 180,
            height: 180
        },

        margin: 20,

        arrow: {
            x: { align: "right", dx: 22 },
            y: { align: "center" }
        }
    }
});
